import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from 'react-dom/client';
import store, { persistor } from "./app/store/store";
import axios from "axios";
import { setupAxios } from "./_metronic";
import App from "./App";
import { pdfjs } from 'react-pdf';

const { PUBLIC_URL } = process.env;

setupAxios(axios, store);
if (process.env.REACT_APP_MOCK_PAINEL_OFERTA !== "false") {
	require("./app/mocks/painelOferta/instalar").instalarMocksDoPainelDeOfertas();
}

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App store={store} persistor={persistor} basename={PUBLIC_URL} />);